// extracted by mini-css-extract-plugin
export var dateLabel = "_3v-0";
export var dateLabelError = "_3v-1";
export var fullWidth = "_3v-2";
export var smaller = "_3v-3";